import React, { PureComponent } from 'react'
import { Pane, Spinner, Dialog, TextInput, toaster } from 'evergreen-ui'

import { Button, Switch, Tooltip, Typography } from "antd";
import { SaveTwoTone, CloseCircleTwoTone, CheckCircleTwoTone, QuestionCircleTwoTone } from '@ant-design/icons';
import "antd/dist/antd.css";

import ImageLoader from 'react-load-image';

import BoundingBox from '../BoundingBox/BoundingBox'
import Title from 'antd/lib/typography/Title';
import { Camera, Tag, BoundingBoxRectangle } from '../../types'
import { SelectValue } from 'antd/lib/select'
import Datafetcher from '../../utils/datafetcher';


const { Text } = Typography;


interface Props {
    stream: string,

    activeCam: Camera | undefined,
    tags: Tag[],

    display: boolean,
    editingTag: boolean,
    datafetcher: Datafetcher,
    editedDetector: SelectValue | null,
    selectedTagPicker: SelectValue | null,

    closeMe: () => void,
    refreshInfo: () => void,
    changeCamToSame: () => void,
}

interface State {
    width: number
    refreshCam: boolean,
    display: boolean,
    editingTag: boolean,
    closed: boolean,

    timeCheckbox: boolean,
    notInFrameCheckbox: boolean,
    boundingBoxCheckbox: boolean,

    donenotInFrameCheckbox: boolean,
    doneboundingBoxCheckbox: boolean,
    donetimeCheckbox: boolean,

    fromEdited: boolean,
    toEdited: boolean,
    resetDone: boolean,

    fromTimeFrame: string | undefined,
    toTimeFrame: string | undefined,
    rect: BoundingBoxRectangle | undefined,

    activeCam: Camera | undefined,
    tags: Tag[]

    newCameraModalShow: boolean,
    addTagModal: boolean,
}

export default class TagEdit extends PureComponent<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = {
            display: this.props.display,
            editingTag: this.props.editingTag,
            activeCam: this.props.activeCam,
            tags: this.props.tags,

            width: 0,

            refreshCam: false,
            closed: false,

            timeCheckbox: false,
            notInFrameCheckbox: false,
            boundingBoxCheckbox: false,

            donenotInFrameCheckbox: false,
            doneboundingBoxCheckbox: false,
            donetimeCheckbox: false,

            fromEdited: false,
            toEdited: false,
            resetDone: false,

            fromTimeFrame: undefined,
            toTimeFrame: undefined,
            rect: undefined,

            newCameraModalShow: false,
            addTagModal: false,
        }
    }

    componentDidMount() {
        this.setState({
            display: this.props.display,
            donenotInFrameCheckbox: false,
            doneboundingBoxCheckbox: false,
            donetimeCheckbox: false,
            fromEdited: false,
            toEdited: false,
            closed: true,
            width: window.innerWidth,
            rect: !this.props.editingTag ? this.getOgRectangle() : undefined
        })
        this.cameraRefresher()
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };

    componentDidUpdate() {
        if (this.state.closed && !this.props.editingTag) {
            this.setState({
                notInFrameCheckbox: false,
                timeCheckbox: false,
                boundingBoxCheckbox: false,
                closed: false,
                donenotInFrameCheckbox: false,
                doneboundingBoxCheckbox: false,
                donetimeCheckbox: false,
                fromEdited: false,
                toEdited: false,
                fromTimeFrame: undefined,
                toTimeFrame: undefined
            })
        }
        this.setState({
            display: this.props.display,
        })
    }

    getTagInfo(a : null | undefined | string) {
        const {tags, editedDetector} = this.props

        if (!this.props.editingTag) {
            return undefined
        }

        for (let i = 0; i < tags.length; i++) {
            if (tags[i].Name === editedDetector) {
                return tags[i]
            }
        }
    }

    changeCoordinates = (rect: BoundingBoxRectangle) => { this.setState({ rect: rect }) }

    checkTime = (time: string) => {
        return /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(time)
    }

    getStream = () => {
        return this.props.stream
    }

    addNewTag = () => {
        const {activeCam, tags} = this.props

        if (!activeCam){return}

        if (this.props.selectedTagPicker === "" || this.props.selectedTagPicker === undefined) {
            toaster.notify('Invalid detector')
            return
        }
        if (this.state.timeCheckbox && (this.state.fromTimeFrame === undefined || this.state.fromTimeFrame === "" || this.state.toTimeFrame === undefined || this.state.toTimeFrame === "")) {
            toaster.notify('Please enter a to and from times.')
            return
        }
        if (this.state.fromTimeFrame && this.state.toTimeFrame) {
            if (this.state.timeCheckbox && (!this.checkTime(this.state.fromTimeFrame) || !this.checkTime(this.state.toTimeFrame))) {
                toaster.notify('Invalid time. It should be in the format of HH:MM.')
                return
            }
        }
        if (this.state.boundingBoxCheckbox && !this.state.rect) {
            toaster.notify('Please draw a bounding box around where you want to scan.')
            return
        }

        if (!activeCam) {
            toaster.notify('Please select an active camera first.')
            return
        }

        let found = false
        let tagName = this.props.selectedTagPicker?.toString()
        if(!tagName){return}

        tags.forEach((val: Tag) => {
        if (val.Name.toLowerCase() === tagName?.toLowerCase()) {
                found = true
            }
        })

        if (found) {
            toaster.notify('This detector is already set.')
            return
        }

        let timePrefab = null

        if (this.state.timeCheckbox && this.state.fromTimeFrame && this.state.toTimeFrame){
            timePrefab = {
                from: this.state.fromTimeFrame,
                to: this.state.toTimeFrame
            }
        }

        this.props.datafetcher.addNewTag(activeCam.id, {
            name: tagName,
            time: timePrefab,
            boundingBox: this.state.boundingBoxCheckbox && this.state.rect ?
                {
                    x: this.state.rect.x / 600,
                    y: this.state.rect.y / 400,
                    w: this.state.rect.w / 600,
                    h: this.state.rect.h / 400,
                } : null,
            negativeDetection: this.state.notInFrameCheckbox
        }, (error: Error | null, _:string | null) => {
            if (error) {
                toaster.notify('Something went wrong.')
                throw (error)
            } else {
                this.setState({
                    newCameraModalShow: false,
                    display: false,
                    resetDone: false,
                })
                this.props.closeMe()
                toaster.notify('New detector successfully added.')
                this.props.refreshInfo()
                this.props.changeCamToSame()
            }
        })
    }

    saveEdit = () => {
        const { activeCam, editedDetector } = this.props
        const { fromTimeFrame, toTimeFrame } = this.state

        if (!activeCam) { return }
        
        if (editedDetector === "" || editedDetector === undefined || typeof editedDetector !== 'string') {
            toaster.notify('Invalid detector')
            return
        }

        const tagInfo: Tag | undefined = this.getTagInfo(null)
        if (!tagInfo) { return }

        const { From, To } = tagInfo

        if (this.checkboxMultiFunc("time")){
            if ((!From || !To) && (fromTimeFrame === "" || toTimeFrame === "")) {
                toaster.notify('Please enter a to and from times.')
                return
            }
            if (fromTimeFrame && toTimeFrame) {
                if ((!this.checkTime(From) || !this.checkTime(To)) && (!this.checkTime(fromTimeFrame) || !this.checkTime(toTimeFrame))) {
                    toaster.notify('Invalid time. It should be in the format of HH:MM.')
                    return
                }
            } 
        }
        
        if (this.checkboxMultiFunc("boundingBox") && (!this.state.rect && !this.getOgRectangle())) {
            toaster.notify('Please draw a bounding box around where you want to scan.')
            return
        }

        let ogRect = this.getOgRectangle()
        if (!ogRect) {
            ogRect = {
                x: 0,
                y: 0,
                w: 0,
                h: 0,
            }
        }
        const { x, y, w, h } = ogRect

        let prefab;
        if (this.checkboxMultiFunc("time") && ((From && To) || (this.state.fromTimeFrame && this.state.toTimeFrame))){
            prefab = {
                from: this.state.fromTimeFrame || From,
                to: this.state.toTimeFrame || To
            }
        }else{
            prefab = null
        }

        const name = editedDetector.toString()
        if(!name){return}

        this.props.datafetcher.editTag(activeCam.id, {
            name: name,
            time: prefab,
            boundingBox: this.checkboxMultiFunc("boundingBox") ?
                (
                    this.state.rect ? {
                        x: this.state.rect && this.state.rect.x / 600,
                        y: this.state.rect && this.state.rect.y / 400,
                        w: this.state.rect && this.state.rect.w / 600,
                        h: this.state.rect && this.state.rect.h / 400
                    } : {
                            x: x / 600,
                            y: y / 400,
                            w: w / 600,
                            h: h / 400,
                        }
                ) : null,
            negativeDetection: this.checkboxMultiFunc("notInFrame"),
            // webhook: this.checkboxMultiFunc("api")
        }, (error: Error | null) => {
            if (error) {
                toaster.notify('Something went wrong.')
                throw (error)
            } else {
                this.setState({
                    newCameraModalShow: false,
                    display: false,
                    resetDone: false
                })
                this.props.closeMe()
                toaster.notify('Detector modified successfully.')
                this.props.refreshInfo()
                this.props.changeCamToSame()
            }
        })
    }

    checkboxMultiFunc = (type: string) => {
        if (!this.getTagInfo(null) || !this.props.editingTag) {
            switch (type) {
                case "time":
                    return this.state.timeCheckbox;
                case "boundingBox":
                    return this.state.boundingBoxCheckbox;
                case "notInFrame":
                    return this.state.notInFrameCheckbox;
            }
        }

        const TagInfo = this.getTagInfo(null)
        if (!TagInfo) { return false}
        const { From, To, X, Y, W, H, NegativeDetection } = TagInfo

        const rules = {
            time: From !== "" && To !== "",
            notInFrame: NegativeDetection,
            boundingBox: X !== 0 && Y !== 0 && W !== 0 && H !== 0
        }

        switch (type) {
            case "time":
                if (!this.state.donetimeCheckbox) {
                    return rules[type]
                } else {
                    return this.state.timeCheckbox
                }
            case "boundingBox":
                if (!this.state.doneboundingBoxCheckbox) {
                    return rules[type]
                } else {
                    return this.state.boundingBoxCheckbox
                }
            case "notInFrame":
                if (!this.state.donenotInFrameCheckbox) {
                    return rules[type]
                } else {
                    return this.state.notInFrameCheckbox
                }
        }
        return false
    }

    getOgRectangle = () => {
        const tagInfo = this.getTagInfo(null)

        if (!tagInfo || this.state.resetDone || !tagInfo.X) { return undefined }

        return {
            x: tagInfo.X * 600,
            y: tagInfo.Y * 400,
            w: tagInfo.W * 600,
            h: tagInfo.H * 400,
        }
    }

    getTagName = () => {
        return this.props.editingTag ? this.props.editedDetector : this.props.selectedTagPicker
    }

    cameraRefresher() {
        const {activeCam} = this.props
        if (!activeCam) {
            setTimeout(() => { this.cameraRefresher() }, 60 * 1000)
            return;
        }
        this.setState({ refreshCam: true })
        setTimeout(() => {
            this.setState({ refreshCam: false })
        }, 500);
        setTimeout(() => {
            this.cameraRefresher()
        }, 60 * 1000);
    }

    renderScreen = () => {
        return (
            this.state.refreshCam ?
            <Pane display="flex"
                flexDirection="row"
                justifyContent="center"
                marginTop={100} marginBottom={100}>
                <Spinner size={100} />
            </Pane>
            :
            <ImageLoader src={ "https://tbackend.usesafewatch.com" + this.getStream() }>
                <img
                    style={{ zIndex: 1, width: "100%", height: "100%", position: 'absolute', top: '0px', left: '0px' }}
                    width={600} height={400}
                    id="cameraFeed"
                    alt="camera feed"
                />
                <div>Error!</div>
                <Pane display="flex" flexDirection="row" justifyContent="center" marginTop={150} marginBottom={100}>
                    <Spinner size={100} />
                </Pane>
            </ImageLoader>
        )
    }

    settings = () => {
        const { width } = this.state;
        const isMobile = width <= 1000;

        return (
            <Pane
                display="flex"
                flexDirection="column"
                overflow="scroll"
                marginTop={isMobile ? 30 : 40}
                marginBottom={isMobile ? 30 : 40}
                marginRight={50}
                marginLeft={isMobile ? 10 : 40}>
                <Title level={2}>Settings for {this.getTagName()} detector</Title>

                <Pane
                    display="flex"
                    flexDirection="row"
                    marginLeft={5}
                    marginBottom={isMobile ? 5 : 10}
                    marginTop={isMobile ? 5 : 25}
                >
                    <Switch
                        checked={this.checkboxMultiFunc("time")}
                        onChange={checked => this.setState({ timeCheckbox: checked, donetimeCheckbox: true })}
                    />
                    <Text style={{ marginLeft: 10 }}>Timeframe</Text>
                    <Tooltip placement="bottom" title={"You can select what part of the day that the detector should alert you on. If the object is detected outside of the timeframe, you won't receive an alert."}>
                        <QuestionCircleTwoTone style={{ marginTop: 5, marginLeft: 10 }} />
                    </Tooltip>

                    {this.checkboxMultiFunc("time") ?
                        <Pane
                            marginLeft={10}
                            marginTop={-5}
                            display="flex"
                            flexDirection="row"
                        >
                            <TextInput
                                placeholder={"00:00"}
                                onChange={
                                    (e: any) => {
                                        this.setState({
                                            fromTimeFrame: e.target.value,
                                            fromEdited: true,
                                        })
                                    }
                                }
                                value={(this.getTagInfo(this.state.fromTimeFrame) && !this.state.fromEdited) ? this.getTagInfo(null)?.From : (this.state.fromTimeFrame || "")}
                                width={80} marginRight={10}>
                            </TextInput>
                            <Text style={{ marginTop: 5, marginRight: 10 }}>to</Text>
                            <TextInput
                                placeholder={"13:00"}
                                onChange={
                                    (e: any) => this.setState({
                                        toTimeFrame: e.target.value,
                                        toEdited: true
                                    })}
                                value={(this.getTagInfo(this.state.toTimeFrame) && !this.state.toEdited) ? this.getTagInfo(null)?.To : (this.state.toTimeFrame || "")}
                                width={80}
                                marginRight={30}
                            ></TextInput>
                        </Pane> : <></>}
                </Pane>


                <Pane
                    display="flex"
                    flexDirection="row"
                    marginLeft={5}
                    marginBottom={isMobile ? 5 : 10}
                    marginTop={25}
                >
                    <Switch
                        checked={this.checkboxMultiFunc("notInFrame")}
                        onChange={checked => this.setState({ notInFrameCheckbox: checked, donenotInFrameCheckbox: true })}
                    />
                    <Text style={{ marginLeft: 10 }}>Not in frame alert</Text>
                    <Tooltip placement="bottom" title={"You can watch for an object, expecting it to be there. You will receive an alert if the object is not in frame. Example use case is expecting a car to be parked, and sending an alert if it's not in the frame."}>
                        <QuestionCircleTwoTone style={{ marginTop: 5, marginLeft: 10 }} />
                    </Tooltip>
                </Pane>

                <Pane
                    display="flex"
                    flexDirection="row"
                    marginLeft={5}
                    marginBottom={isMobile ? 5 : 10}
                    marginTop={25}
                >
                    <Switch
                        checked={this.checkboxMultiFunc("boundingBox")}
                        onChange={checked => {
                            this.setState({
                                boundingBoxCheckbox: checked,
                                doneboundingBoxCheckbox: true
                            })
                        }}
                    />
                    <Text style={{ marginLeft: 10 }}>Watch a specific region</Text>
                    <Tooltip placement="bottom" title={"You can select a bounding box for where the detector is going to scan. Draw the bounding box by clicking and dragging your mouse on the image. Make sure to make the box around 5% bigger than the object is supposed to be. If it's not selected the whole frame is going to be scanned."}>
                        <QuestionCircleTwoTone style={{ marginTop: 5, marginLeft: 10 }} />
                    </Tooltip>
                </Pane>
                <Pane
                    marginTop={10}
                    marginBottom={isMobile ? 0 : 10}
                >
                    {this.checkboxMultiFunc("boundingBox") && (this.state.rect || this.getOgRectangle()) ?
                        <>
                            <Text style={{ marginRight: 5 }}>Selection made</Text>
                            <Button
                                onClick={
                                    () => {
                                        this.setState({
                                            boundingBoxCheckbox: false,
                                            doneboundingBoxCheckbox: true,
                                            rect: undefined,
                                            resetDone: true
                                        })
                                    }
                                }>Reset</Button>
                        </> : <></>
                    }
                </Pane>

                {/* <Pane
                    display="flex"
                    flexDirection="row"
                    marginLeft={5}
                    marginBottom={isMobile ? 5 : 10}
                    marginTop={isMobile ? 5 : 25}
                >
                    <Switch
                        checked={this.checkboxMultiFunc("api")}
                        onChange={checked => this.setState({ apiCheckbox: checked, doneapiCheckbox: true })}
                    />
                    <Text style={{ marginLeft: 10 }}>Webhook</Text>
                    <Tooltip placement="bottom" title={"Send a call to a webhook when this object is detected by your camera."}>
                        <QuestionCircleTwoTone style={{ marginTop: 5, marginLeft: 10 }} />
                    </Tooltip>

                    {this.checkboxMultiFunc("api") ?
                        <Pane
                            marginLeft={10}
                            marginTop={-5}
                            display="flex"
                            flexDirection="row"
                        >
                            <TextInput
                                placeholder={"https://example.com/webhook"}
                                onChange={
                                    (e: any) => this.setState({
                                        api: e.target.value,
                                        apiEdited: true,
                                    })
                                }
                                value={(this.getTagInfo() && !this.state.apiEdited) ? this.getTagInfo().Api : this.state.api}
                                width={150} marginRight={10}>

                            </TextInput>
                        </Pane> : <></>}
                </Pane> */}

                <Pane marginTop={isMobile ? 10 : 25}>
                    {this.props.editingTag ?
                        <Button shape="round" style={{ marginRight: 5 }} onClick={this.saveEdit}><SaveTwoTone /></Button> :
                        <Button shape="round" type="primary" style={{ marginRight: 5 }} onClick={this.addNewTag}><CheckCircleTwoTone /></Button>
                    }
                    <Button shape="round" danger={true} onClick={() => { this.setState({ addTagModal: false, display: false }); this.props.closeMe(); }}><CloseCircleTwoTone twoToneColor="red" /></Button>
                </Pane>
            </Pane >)
    }

    render() {
        const { width } = this.state;
        const isMobile = width <= 1000;

        return (
            <Dialog
                isShown={this.state.display}
                onCloseComplete={() => {
                    this.setState({
                        display: false,
                        resetDone: false,
                        closed: true,
                    })
                    this.props.closeMe()
                }}
                hasFooter={false}
                hasHeader={false}
                width={"fit-content"}
            >
                {!isMobile ? <Pane
                    display="flex"
                    flexDirection="row"
                >
                    <Pane
                        display="flex"
                        borderRadius={5}
                        flexDirection="column"
                        minWidth="600px"
                        margin={isMobile ? -16 : "inherit"}
                    >
                        <div style={{ width: isMobile ? "100%" : 600, height: isMobile ? 200 : 400 }}>
                            <div style={{ width: "100%", height: "100%", position: 'relative' }}>
                                {this.renderScreen()}
                                {this.checkboxMultiFunc("boundingBox") ?
                                    <BoundingBox
                                        ogRect={this.getOgRectangle()}
                                        changeCoordinates={this.changeCoordinates}
                                        width={600}
                                        height={400}
                                    >
                                    </BoundingBox> : <></>}
                            </div>
                        </div>
                    </Pane>
                    {!isMobile ? this.settings() : <></>}
                </Pane> : <></>}
                {isMobile ? this.settings() : <></>}
            </Dialog>
        )
    }
}